// extracted by mini-css-extract-plugin
module.exports = {"loading_spinner":"style_loading_spinner__2m-as","loading":"style_loading__1l-ja"};